import { h } from 'preact'
import styles from './LogoSection.module.css'
import { useCustomContext } from '../../lib/context'

//const vmLogoBig = require('../../static/vm-logo-big.svg').default

export function LogoSection() {
  const context = useCustomContext()
  const handleClick = (event) => {
    if (!context) return
    const anchor = event.target.closest('a')
    if (!anchor) return
    context.sendGaEvent({ eventAction: 'click', eventLabel: anchor.getAttribute('href') })
  }
  return (
    <div class={styles['dh-fotball-banner__logoSection']}>
      <div class={styles['dh-fotball-banner__logoSection-nologo']}>Fotball-EM 2024</div>
      <div class={styles['dh-fotball-banner__logoSection-links']}>
        <a onClick={handleClick} href="https://resultater.nrk.no/">
          <span>Alle kamper</span>
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path
              d="M11.6668 6.99999L8.8085 2.91666H7.48299L9.93299 6.41666H2.3335L2.91683 7.58332H9.93299L7.48299 11.0833H8.8085L11.6668 6.99999Z"
              fill="#649BE2"
            />
          </svg>
        </a>
      </div>
    </div>
  )
}
